import React from 'react';
import { useTranslation } from 'react-i18next';

import { FitnessApplicationActivityType } from '../../../types/__generated__';
import config from '../../client/config';
import useFitnessAuth from '../../hooks/fitness/useFitnessAuth';
import { FitnessManager } from './FitnessManager';

import styles from './FitnessManager.scss';

export function FitbitManager() {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <FitnessManager
      fitnessApplicationName="fitbit"
      text={{
        paused: {
          status: t('fitnessSection.fitbit.status.paused'),
          description: t('fitnessSection.fitbit.description.paused'),
        },
        connected: {
          status: t('fitnessSection.fitbit.status.connected'),
          description: t('fitnessSection.fitbit.description.connected'),
        },
        disconnected: {
          status: '',
          description: t('fitnessSection.fitbit.description.notConnected'),
        },
      }}
      url={{
        compliance: '',
      }}
    >
      <FitnessManager.FitnessLogo>
        <FitnessManager.FitnessLogo.Fitbit />
      </FitnessManager.FitnessLogo>
      <FitnessManager.ActivityTotals
        showFilterButtons={false}
        showOverallCompleted={false}
      />
      <FitnessManager.SettingsButton
        text={t('fitbit.settingsButton')}
        className={styles.fitbitButton}
      />
      <FitnessManager.ConnectButton
        text={t('fitbit.connectButton')}
        className={styles.fitbitButton}
        onClick={useFitnessAuth(config.fitbit)}
      />
      <FitnessManager.AddManualActivityButton
        text={t('fitness.addManualActivity')}
        className={styles.button}
      />
      <FitnessManager.Settings>
        <FitnessManager.Settings.ActivityTypes
          activityTypes={[FitnessApplicationActivityType.Walk]}
        />
        <FitnessManager.Settings.DisplayPreferences>
          <FitnessManager.Settings.DisplayPreferences.ShowTotaliser />
        </FitnessManager.Settings.DisplayPreferences>
      </FitnessManager.Settings>
      <FitnessManager.AddManualActivity
        title={t('manualFitness.modalTitle.fitbit')}
        activities={[FitnessApplicationActivityType.Walk]}
      >
        <FitnessManager.AddManualActivity.DatePicker />
        <FitnessManager.AddManualActivity.Steps />
        <FitnessManager.AddManualActivity.Title />
        <FitnessManager.AddManualActivity.Story />
        <FitnessManager.AddManualActivity.ImageUpload />
      </FitnessManager.AddManualActivity>
    </FitnessManager>
  );
}
